import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProfileDropdownService {
  isOpen = signal(false);
}
